<div class="bg-m1 flex h-full cursor-default flex-col">
  <div
    class="flex h-2 flex-1 flex-row items-center justify-center overflow-y-auto"
  >
    <div class="flex w-96 flex-col items-center space-y-5 py-[50px]">
      <div>
        <m-completed-ring></m-completed-ring>
      </div>

      <div
        data-cy="newPasswordWasSetTitle"
        class="text-s2 select-none text-2xl font-semibold"
        >{{ pageTitle }}</div
      >
      <div class="text-s1 text-center text-base"
        >To sign in now, just click below.</div
      >

      <button
        data-cy="newPasswordWasSetLoginButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        (click)="login()"
        >Log In</button
      >
    </div>
  </div>
</div>
